import { Component, OnInit, Input } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';

@Component({
	selector: 'app-image-lightbox',
	templateUrl: './image-lightbox.component.html',
	styleUrls: ['./image-lightbox.component.scss']
})
export class ImageLightboxComponent implements OnInit {

	@Input() imageUrl: string;
	@Input() style: string;
	public _albums = [];

	constructor(
		private _lightbox: Lightbox
	) { }

	ngOnInit() {
		this._albums.push({
			src: this.imageUrl,
			caption: 'Zdjęcie',
			thumb: this.imageUrl
		});
	}

	open(index: number): void {
		this._lightbox.open(this._albums, index);
	}

	close(): void {
		this._lightbox.close();
	}
}
